import React from 'react';
import loader from '../../assets/loading.svg';
import { useAppTranslation } from '../../hooks/useAppTranslation';
import { Overlay } from './styles';

interface LoadingProps {
  withOverlay?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ withOverlay = true }) => {
  const { translationPage } = useAppTranslation();
  const { tp } = translationPage(tr => tr.components.loading);
  const altText = tp('alt');

  return (
    <>
      {withOverlay ? (
        <Overlay>
          <img src={loader} alt={altText} />
        </Overlay>
      ) : (
        <img src={loader} alt={altText} />
      )}
    </>
  );
};

export default Loading;
